import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { OVERALL_CATEGORY } from '../config'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'
import { setItemValuesUniversal } from './setItemValuesUniversal'

interface IUpdateOverallTotalProps {
  items: IJBPPlanningItem[]
  setting: IFormActualsTargetsSettings
  fieldProps: IFieldProps
  fy: number
  fq: number
  isL3DetailRow: boolean
  partnerId: string
  isIgnorePartnerId: boolean
  translationFactors?: ITranslationFactors[] | null
}

interface IUpdateOverallTotalResult {
  isUpdated: boolean
  updatedItems: IJBPPlanningItem[]
}

export const updateOverallTotal = ({
  items,
  setting,
  fieldProps,
  fy,
  fq,
  isL3DetailRow,
  partnerId,
  isIgnorePartnerId,
  translationFactors,
}: IUpdateOverallTotalProps): IUpdateOverallTotalResult => {
  const updatedItems = [...items]
  const fieldName = getFieldName(fieldProps)
  const subCategoryForOverall = isL3DetailRow ? setting.SubCategory : OVERALL_CATEGORY

  const overallCategoryData = items.filter(
    (item) =>
      (item.PartnerId === partnerId || isIgnorePartnerId) &&
      item.ProgramTypes === setting.ProgramType &&
      item.Category === setting.Category &&
      // Only Category overall
      item.SubCategory === subCategoryForOverall &&
      (!isL3DetailRow || item.L3Category === OVERALL_CATEGORY) &&
      item.FYear === fy &&
      item.FQuarter === fq
  )

  if (!overallCategoryData.length) {
    return { isUpdated: false, updatedItems }
  }

  // Calc Total
  const subCategoryData = items.filter(
    (item) =>
      (item.PartnerId === partnerId || isIgnorePartnerId) &&
      item.ProgramTypes === setting.ProgramType &&
      item.Category === setting.Category &&
      // Only Sub-categories
      ((!isL3DetailRow && item.SubCategory !== OVERALL_CATEGORY) ||
        (isL3DetailRow && item.SubCategory === setting.SubCategory)) &&
      ((!isL3DetailRow && (!item.L3Category || item.L3Category === OVERALL_CATEGORY)) ||
        (isL3DetailRow && item.L3Category !== OVERALL_CATEGORY)) &&
      item.FYear === fy &&
      item.FQuarter === fq
  )

  let total: number | null = null
  subCategoryData.forEach((item) => {
    const value = item[fieldName]
    if (value || value === 0) {
      total = (total ?? 0) + Number(value || 0)
    }
  })

  // Set Total
  const newItem = setItemValuesUniversal(
    overallCategoryData[0],
    total,
    fieldProps,
    setting.Category,
    false,
    translationFactors
  )
  const index = items.indexOf(overallCategoryData[0])
  updatedItems.splice(index, 1, newItem)

  return { isUpdated: true, updatedItems }
}
